import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { ErorsMessage } from 'app/e-form/helper/script/error-message';
import { TranslateService } from '@ngx-translate/core';
import { codes, symbols, mapping } from '../../../config/currency';
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-currency-properties',
   templateUrl: './currency-properties.component.html',
   styleUrls: ['./currency-properties.component.scss'],
   providers: [DecimalPipe]
})
export class CurrencyPropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: any;
   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   errMsg = new ErorsMessage(this.translate);
   codes = codes;
   symbols = symbols;
   currencies = [];
   curr: string;
   order: string;
   currentType: string;
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   startMaxLength: number;
   endMaxLength: number;
   number: any;
   constructor(public translate: TranslateService, private _decimalPipe: DecimalPipe) { }

   ngOnInit(): void {
      this.currencies = this._getValue('type') === 'code' ? codes : symbols;
      this.startMaxLength = 12;
      this.endMaxLength = 12;
      this.order = this._getValue('order');
      if (!this.order) {
         this.order = '฿';
         this._setOption('฿', 'order');
      }
      let currency = this._getOption('currency');
      if (this._getValue('type') === 'code') {
         this.currentType = 'code';
         if (!currency) {
            this._setOption('THB', 'currency');
            this.curr = 'THB';
         } else {
            this._setOption(currency, 'currency')
            this.curr = currency;
         }
      } else {
         this.currentType = 'symbol';
         if (!currency) {
            this._setOption('฿', 'currency');
            this.curr = '฿';
         } else {
            this._setOption(currency, 'currency')
            this.curr = currency;
         }
      }
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   updateRange() {
      setTimeout(() => {
         this.getField.get('rangeStart').updateValueAndValidity();
         this.getField.get('rangeEnd').updateValueAndValidity();
      }, 500);
   }

   _setOption(value: any, type: string) {
      if (this.table) {
         this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex).get(type).setValue(value);
         this.helper.getFieldTableAsFormArray(this.eForm, this.state.sectionIndex, this.state.fieldIndex).updateValueAndValidity();
      } else {
         this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex).get(type).setValue(value);
         this.helper.getFieldAsFormArray(this.eForm, this.state.sectionIndex).updateValueAndValidity();
      }
   }

   _getOption(type: string): string {
      let value = '';
      if (this.table) {
         value = this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex).get(type).value;
      } else {
         value = this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex).get(type).value;
      }
      return value;
   }

   setValue(): void {
      const type = this._getValue('type');
      this.order = this._getOption('order');
      let currency = this._getOption('currency');
      if (currency) {
         this.curr = currency;
      }
      const orderArr = this.toOrderArray();
      let curr = this.curr;
      if (!this.isCode(curr)) {
         if (type === 'code') {
            curr = this.getCodeValue(curr,orderArr);
         }

      } else {
         if (type === 'symbol') {
            curr = this.getSymbolVallue(curr,orderArr);
         }
      }

      this._setOption(curr, 'currency');
      this._setOption(this.order, 'order');

      this.curr = curr;
      this.order = '';
      this.currentType = type;
   }

   getCodeValue(value: string,orderArr: string[]): string {
      const curr = this.searchSymbol(value,'code',orderArr);
      if (value === 'K') {
         orderArr = orderArr.filter(item => item !== 'Ks.');
      } else if (value == 'Ks.') {
         orderArr = orderArr.filter(item => item !== 'K');
      }
      this.order = orderArr.toString();
      const arr = curr.split('_');
      return (arr.length > 0 ? arr[0]:'');
   }

   getSymbolVallue(value: string,orderArr: string[]): string {
      const code = this.getCode(value,orderArr);
      const curr = mapping[code];
      this.searchSymbol(curr,'code',orderArr);
      this.order = orderArr.toString();
      const arr = curr.split('_');
      return (arr.length > 0 ? arr[0]:'');
   }


   searchSymbol(value: string,type: string,orderArr: string[]): string{
      let arr = value.split('_');
      let tmp = '';
      let val = '';
      let key = '';
      if (!this.isCode(arr[0])) {
         if (arr.length > 0) {
            if (arr.length === 1) {
               val = this.searchOrder(orderArr,value);
               tmp = mapping[val];
               if (!tmp) {
                  tmp = mapping[value];
                  if (!tmp) {
                     tmp = mapping[value + '_1'];
                     key = value + '_1';
                  } else {
                     key = value;
                  }
               } else {
                  tmp = mapping[val];
                  key = val;
               }
            } else {
               val = this.searchOrder(orderArr, value);
               tmp = mapping[val];
               if (!tmp) {
                  tmp = mapping[arr[0] + '_' + arr[1]];
                  key = arr[0] + '_' + arr[1];
                  if (!tmp) {
                     tmp = mapping[arr[0] + '_1'];
                     key = arr[0] + '_1';
                  }
               } else {
                  tmp = mapping[value];
                  key = value;
               }
            }
            val = this.searchOrder(orderArr, arr[0]);
            if (val) {
               this.replaceOrder(orderArr,arr[0],key);
            } else {
               orderArr.push(key);
            }
            if (type === 'symbol') {
               tmp = key;
            } else {
               tmp = mapping[key];
            }
         }
      } else {
         tmp = arr[0];
      }
      return tmp;
   }

   getCode(value: string, arr: string[]): string{
      let code;
      let curr = mapping[value];
      if (!curr) {
         if (value === 'MMK') {
            curr = this.searchOrder(arr,'K');
            if (!curr) {
               curr = this.searchOrder(arr,'Ks.');
               if (!curr) {
                  code = 'MMK_1'
               } else{
                  code = 'MMK_2';
               }
            } else {
               code = 'MMK_1';
            }
         } else {
            code = value;
         }
      } else {
         code = value;
      }
      return code;
   }

   toOrderArray(): string[] {
      let result = [];
      if (this.order) {
         result = this.order.split(',');
      }
      return result;
   }

   searchOrder(arr: string[],symbol: string): string {
      const index = arr.findIndex(o => o.split('_')[0] === symbol);
      if (index > -1) {
         return arr[index];
      }
      return '';
   }

   replaceOrder(arr: any[], symbol: string, value: string) {
      const index = arr.findIndex(o => o.split('_')[0] === symbol);
      if (index > -1) {
         arr[index] = value;
      } else {
         arr.push(value);
      }
   }

   _changeOption(type: string) {
      if (type === 'symbol') {
         this.currencies = symbols;
      } else {
         this.currencies = codes.sort((a, b) => a.localeCompare(b));
      }
   }

   _updateRange(type: string, v: string) {
      const _s = v.replace(/,/g, '');
      const _gobalFloat = parseFloat(_s);
      if (_s.startsWith('-')) {
         const _float = parseFloat(_s.substring(1));
         if (Math.round(_float * 100000) === 0) {
            this.getField.get(type).patchValue('0');
         } else if (!_s.endsWith('-')) {
            if (isNaN(+ _s)) {
               this.getField.get(type).patchValue('0');
            } else {
               let _string = '';
               if (_s.length === 15 && _s.indexOf('.') === 1) {
                  _string = _float.toFixed(12).toString();
               } else {
                  _string = _float.toString();
               }
               this.getField.get(type).patchValue('-' + _string, { emitEvent: false, emitModelToViewChange: false });
            }
         }
      } else if (Math.round(_gobalFloat * 100000) === 0) {
         this.getField.get(type).patchValue('0');
      } else if (_s) {
         const _int = + _s;
         let _value = '';
         if (_s.length === 15 && _s.startsWith('.')) {
            _value = isNaN(_int) ? '0' : _int.toFixed(13).toString();
         } else {
            _value = isNaN(_int) ? '0' : _int.toString();
         }
         this.getField.get(type).patchValue(_value, { emitEvent: false, emitModelToViewChange: false });
      }
   }

   onFocus(type: string, value: string) {
      if (type === 'rangeStart') {
         this.startMaxLength = 12;
      } else {
         this.endMaxLength = 12;
      }
      value = value.replace(/ /g,'');
      value = value.replace(/,/g, '');
      this.getField.get(type).setValue(value);
   }

   onBlur(type: string, value: string) {
      value = value.replace(/\s/g, '');
      value = value.replace(/,/g, '');
      value = value.replace(/ /g,'');
      if (value.indexOf('.') === -1) {
         this.number = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
         this.number = + value;
         if (isNaN(this.number)) {
            this.number = value;
         } else {
            const splNumber = this.number.toString().split('.')[0];
            const splDecimal = this.number.toString().split('.')[1];
            if (splDecimal) {
               this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + splDecimal;
            } else {
               this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
         }
      }
      let invalid = this.getField?.get(type)?.status === 'INVALID';
      this.getField?.get(type)?.setValue(Number(this.number) === 0 ? '':this.number);
      let count = 0 | this.number.match(/\,/g)?.length;
      if (type === 'rangeStart') {
         this.startMaxLength += count;
      } else {
         this.endMaxLength += count;
      }
      if (!invalid) {
         this.getField.get(type).setErrors(null);
      }
   }

   get getField() {
      if (this.table) {
         return this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
      }
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }

   isCode(value: string): boolean {
      return this.codes.indexOf(value) > -1;
   }

   isNanValue(value) {
      return isNaN(value);
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

   _getValue(type: string) {
      if (this.table) {
         return this.helper.getFieldTableSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
      }
      return this.helper.getFieldSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex);
   }


}
